// Dairy logo upload rules, mirrored from the collector API docs (section 3.4):
// PNG, JPG, or WebP only; max 2 MB.

export const LOGO_MAX_SIZE_BYTES = 2 * 1024 * 1024;

export const LOGO_ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

// Client-side pre-check before uploading.
// Returns { valid, errorKey } where errorKey is a translation key for the failure reason.
export const validateLogoFile = (file) => {
  if (!file) {
    return { valid: false, errorKey: 'logoSelectFile' };
  }
  if (!LOGO_ALLOWED_MIME_TYPES.includes(file.type)) {
    return { valid: false, errorKey: 'logoMustBePngJpgWebp' };
  }
  if (file.size > LOGO_MAX_SIZE_BYTES) {
    return { valid: false, errorKey: 'logoMustBe2MbOrSmaller' };
  }
  return { valid: true, errorKey: null };
};

// Maps a backend logo validation error to a translation key by matching
// message fragments, per the API docs' frontend tip: the 400 envelope wraps
// the serializer error inside a stringified `error` field, so match text
// fragments instead of parsing it.
// The envelope ends with code='invalid' for ALL logo errors, so never match
// the bare word "valid" — match the full "Upload a valid" fragment instead.
export const logoApiErrorKey = (error) => {
  const raw = error?.response?.data?.error || error?.message || '';
  const text = String(raw);

  if (text.includes('2 MB')) {
    return 'logoMustBe2MbOrSmaller';
  }
  if (text.includes('Upload a valid')) {
    return 'logoUploadValidImage';
  }
  if (text.includes('PNG, JPG, or WebP')) {
    return 'logoMustBePngJpgWebp';
  }
  return null;
};
